<template>
  <div>
    <el-upload
      class="upload-demo"
      drag
      action="pos/v1/post-images/"
      name="avatar"
      accept="image/*"
      multiple
    >
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">將文件拖到此處，或點擊上傳</div>
      <div class="el-upload__tip" slot="tip">只能上傳jpg/png文件</div>
    </el-upload>
    <el-divider />
    <div>
      <el-button @click="show_edit()">顯示圖片</el-button>
      <!-- {{ images }} -->
    </div>
    <van-grid column-num="6">
      <van-grid-item v-for="r in images" :key="r" @click="pick(r)">
        <!-- <van-image :src="r" radius="0.5rem" fit="fill" lazy-load> </van-image> -->
        <el-image :src="r" lazy></el-image>
      </van-grid-item>
    </van-grid>
  </div>
</template>

<style scoped></style>

<script>
// import ImageEdit from "./image-edit.vue";
// Vue.component('ImageEdit', ImageEdit);
export default {
  props: {
    data: Array,
  },
  components: {
    // ImageEdit: ImageEdit,
  },
  data() {
    return {
      imageUrl: "",
      images: [],
    };
  },
  methods: {
    handleAvatarSuccess: function (res, file) {
      console.log(res, file);
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    show_edit: async function () {
      var res = await this.apiGetImages();
      this.images = res.data;
      this.images = this.images.map((r) => {
        return this.$path.join("upload", r);
      });
      console.log(res);
    },
    pick: function (src) {
      this.gSure("確認刪除圖片" + src)
        .then(async () => {
          // fulfillment
          let body = { image: src };
          var res = await this.apiDeleteImage(body);
          console.log("del", res);
          await this.show_edit();
        })
        .catch((error) => {
          // fulfillment
          console.log("cancel", error);
        });
    },
  },
};
</script>



<style scoped>
.img {
  /* background-image: url(../../assets/cloud.png); */
  /* background-image: url('http://localhost:8080/images/1.png'); */
  background-size: 100px;
  background-repeat: no-repeat;
  height: 5rem;
  width: 100px;
  line-height: 4rem;
  text-align: center;
  font-size: 0.8rem;
  overflow: hidden;
  position: absolute;
}
.back {
  font-size: 2rem;
}
.used {
  background-color: rgba(1, 1, 1, 0.6);
  position: absolute;
  width: 99%;
  height: 99%;
  z-index: 10;
  margin: 0.5%;
}
.van-image {
  position: absolute;
  /* width: 5rem; */
  margin: 1rem;
}
.van-grid-item {
  height: 20rem;
}
.van-popup {
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  margin: auto;
  width: 100%;
  height: 100%;
}
.main {
  text-align: left;
  padding: 1rem;
}
</style>